/*
 * @Author: zhang lin
 * @Date: 2022-04-11 19:26:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-09 15:16:56
 * @Description: file content
 */
import axios from 'axios';
import { message } from 'sup-ui';
import { createClientSymbol } from 'sup-rc-utility';

// 创建一个axios
const request = axios.create({});
// 请求拦截器
request.interceptors.request.use((config) => {
  // 如果tiket存在  获取并设置在请求头中
  const ticket = localStorage.getItem('ticket');
  const runtimeEnvId = sessionStorage.getItem('runtimeEnvId');
  const clientId = createClientSymbol('ops_manager');

  if (ticket && config.headers) {
    config.headers.Authorization = ticket;
  }
  if (runtimeEnvId && config.headers) {
    config.headers['X-Runtime-Env-Id'] = runtimeEnvId;
  }
  if (!runtimeEnvId && window.location.hash === '#/instances') {
    window.hashHistory.push('/envManage');
    return config;
  }

  if (config.headers) config.headers['X-Supos-Client'] = clientId;

  return config;
});

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    return Promise.resolve(res);
  },
  (err) => {
    const { response } = err;

    // 取消请求
    if (axios.isCancel(err)) {
      // console.log('取消请求');
    } else if (response?.status === 401 || response?.data?.code === '000063') {
      // 处理token失效
      message.error(response?.data?.message);
      window.location.href = '/#/login';
    } else if (checkCustom(response)) {
      // 部分特定接口不弹框提示

      return Promise.reject(response);
    } else {
      // 错误的弹出时候提示信息
      message.error(response?.data?.message || response?.statusText || '请求失败');
    }

    return Promise.reject(response);
  },
);

export default request;

// 自定义需要特殊处理的
function checkCustom(response: any) {
  // 判断登录接口并且错误类型未帐号密码错误类型
  if (
    response?.config?.url.indexOf('supos/login') > -1 &&
    ['000061', '000062', '000064'].includes(response?.data?.code)
  ) {
    return true;
  }
}
